import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B] text-[#A3A3A3]">
        <span className="font-accent tracking-[0.3em] text-xs uppercase">Loading…</span>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
